// Components
import GDImageViewer from "../components/shared/GDImageViewer";
import SingleGalleryImage from "../components/gallery/SingleGalleryImage ";
import Hero from "../components/layout/Hero";

// Assets
import heroImg from "../assets/images/gallery/hero.jpg";
import "../assets/styles/gallery.css"

// Hooks
import { useTranslation } from "../hooks/useTranslation";

export default function Gallery() {
    const DIR_ID = process.env.REACT_APP_GD_GALLERY_DIR_ID;
    const GDRIVE_KEY = process.env.REACT_APP_GD_API_KEY;
    const t = useTranslation();

    return (
        <section id="gallerySection">
            <Hero
                bgImage={heroImg}
                title={t("gallery.title")}
            />

            <div className="galleryList">
                <GDImageViewer
                    data={{
                        dirId: DIR_ID,
                        gkey: GDRIVE_KEY,
                        options: {
                            hover: true,
                            onClick: { modal: true },
                            switchArrows: true,
                            exclude: { "README.png": true },
                            loadingText: t("gallery.loading"),
                        },
                    }}
                    className="galleryCard"
                    classes={{ /* overrides, if any */ }}
                    styles={{ /* overrides, if any */ }}
                    ImageComponent={SingleGalleryImage}
                />
            </div>
        </section>
    );
}
